import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, addAccount } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    // Standard Google OAuth 2.0 callback — ?code=...
    if (code) {
      const redirectUri = window.location.origin + "/auth/callback";
      (async () => {
        try {
          const { data } = await api.post("/auth/google/callback", { code, redirect_uri: redirectUri });
          if (data.token && addAccount) {
            addAccount({ ...data.user, token: data.token });
          } else {
            setUser(data.user);
          }
          if (data.token) localStorage.setItem("token", data.token);
          window.history.replaceState(null, "", "/app");
          navigate("/projects", { state: { user: data.user } });
        } catch {
          navigate("/login");
        }
      })();
      return;
    }

    // Legacy Emergent session_id flow — #session_id=... (kept for backward compat)
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (match) {
      const session_id = match[1];
      (async () => {
        try {
          const { data } = await api.post("/auth/session", { session_id });
          if (data.token && addAccount) {
            addAccount({ ...data.user, token: data.token });
          } else {
            setUser(data.user);
          }
          window.history.replaceState(null, "", "/app");
          navigate("/projects", { state: { user: data.user } });
        } catch {
          navigate("/login");
        }
      })();
      return;
    }

    navigate("/login");
  }, [navigate, setUser, addAccount]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
      <div className="meta-label">// AUTHENTICATING...</div>
    </div>
  );
}
